module.exports = __webpack_public_path__ + "img/306.02f12ff9.png";